import { render, staticRenderFns } from "./LcSwitch.vue?vue&type=template&id=402bf174&scoped=true"
import script from "./LcSwitch.vue?vue&type=script&lang=js"
export * from "./LcSwitch.vue?vue&type=script&lang=js"
import style0 from "./LcSwitch.vue?vue&type=style&index=0&id=402bf174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402bf174",
  null
  
)

export default component.exports